import moment from "moment";

const isObject = (obj: unknown) =>
   typeof obj === "object" && obj !== null && !Array.isArray(obj) && !moment.isMoment(obj);

const combineKeys = (parentKey: string | undefined, childKey: string) =>
   parentKey ? `${parentKey}.${childKey}` : childKey;

export const deepMap = (
   func: (v: unknown, deepKey: string) => unknown,
   obj: object,
   parentKey?: string
): object => {
   return Object.keys(obj as object).reduce((acc, key) => {
      const deepKey = combineKeys(parentKey, key);
      if (isObject(obj?.[key])) {
         acc[key] = deepMap(func, obj[key], deepKey);
      } else  if (Array.isArray(obj?.[key])) {
         acc[key] = obj?.[key].map((item, i) => {
            const arrayKey = `${deepKey}.${i}`;
            if(isObject(item)) {
               return deepMap(func, item, arrayKey);
            } else {
               return func(item, arrayKey);
            }
         })
      } else {
         acc[key] = func(obj[key], deepKey);
      }
      return acc;
   }, {});
};

export const hasKeyInArray = <T = string | RegExp>(array: T[], key: string) => {
   return array.some(k => {
      if(k instanceof RegExp) {
         return k.test(key)
      }
      return k === key
   })
}
